/* global modForm */
export const updateTabIndexes = function() {
	if (modForm.opts.steps && modForm.opts.steps.length) {
		modForm.opts.steps.forEach(function(step) {
			if (step) {
				const stepFields = step.querySelectorAll('input, select, textarea');
				if (stepFields.length) {
					stepFields.forEach(function(field) {
						if (field) {
							if (step.classList.contains(modForm.opts.stepActiveCls)) {
								field.removeAttribute('tabindex');
							} else {
								field.setAttribute('tabindex', '-1');
							}
						}
					});
				}
			}
		});
	}
};
